/// <reference path="../../meevoMessenger.module.ts" />

module Meevo.Plugins.Controls {
    class AutoReplyModalController {

        static $inject = [
            "handleConfirm",
            "selectionOptions",
            "$mdDialog"]

        public handleConfirm: any;
        public transferData: string | [string];
        public selectionOptions;

        public selectedOption;

        constructor(handleConfirm: any,
                    selectionOptions: [any],
                    private $mdDialog: angular.material.IDialogService) {

            this.handleConfirm = handleConfirm;
            this.selectionOptions = selectionOptions;
        }

        apply = () => {
            this.$mdDialog.hide();
            this.handleConfirm(this.selectedOption);
        }

        cancel = () => {
            this.$mdDialog.hide();
        }
    }

    angular.module("meevo.plugins.meevoMessenger")
        .controller("meevo.plugins.AutoReplyModalController", AutoReplyModalController);
}
